import axios from 'axios';
import config from '@/config';
import { pgyqManageService } from '@/features/xfaqpg/pgyqgl/pgyq.service.js';

const baseUrl = `${config.ctx.iffApi}/jxxf/pg`;

function projectFromJx (project = {}) {
  return {
    ...project,
    id: project.xmId,
    wtdw: project.wtdwmc,
    shxydm: project.wtdwshxydm,
    lxr: project.wtdwlxr,
    lxdh: project.wtdwlxdh,
    areaDm: project.xzqydm,
    ztDm: project.xmzt,
    pgrqq: project.pgrqQ,
    pgrqz: project.pgrqZ
  };
}

function projectToJx (project = {}) {
  return {
    xmmc: project.xmmc,
    xmdz: project.xmdz,
    xzqydm: project.areaDm,
    wtdwmc: project.wtdw,
    wtdwshxydm: project.shxydm,
    wtdwlxr: project.lxr,
    wtdwlxdh: project.lxdh,
    wtdwdz: project.wtdwdz,
    jzlbDm: project.jzlbDm,
    gldw: project.gldw,
    wbdw: project.wbdw,
    bgbxr: project.bgbxr,
    xmfzr: project.xmfzr,
    bgspr: project.bgspr,
    bgpzr: project.bgpzr,
    pgrqQ: project.pgrqQ,
    pgrqZ: project.pgrqZ,
    pgfw: project.pgfw,
    pgqksm: project.pgqksm,
    dwjbqk: project.dwjbqk,
    jzjbqk: project.jzjbqk,
    pgyj: project.pgyj,
    lockVersion: project.lockVersion
  };
}

function queryToJx (params = {}) {
  const result = {
    xmmc: params.xmmc,
    wtdwmc: params.wtdw,
    bgbh: params.bgbh,
    xmzt: params.xmzt,
    pageNo: params.pageNo,
    pageSize: params.pageSize
  };
  if (Array.isArray(params.ztDm) && params.ztDm.length === 1) {
    result.xmzt = params.ztDm[0];
  } else if (!Array.isArray(params.ztDm)) {
    result.xmzt = params.ztDm;
  }
  return result;
}

function mapPageResponse (response) {
  const data = response.data || {};
  return {
    ...response,
    data: {
      ...data,
      rows: (data.rows || []).map(projectFromJx)
    }
  };
}

function mapInstrumentOption (item = {}) {
  const validUntil = typeof item.yxq === 'number' ? new Date(item.yxq) : null;
  const validUntilText = validUntil && !Number.isNaN(validUntil.getTime())
    ? `${validUntil.getFullYear()}-${String(validUntil.getMonth() + 1).padStart(2, '0')}-${String(validUntil.getDate()).padStart(2, '0')}`
    : item.yxq;
  return {
    yqId: item.id,
    yqmc: item.sbmc,
    yqbh: item.sbbh,
    jdzsbh: item.jyzjbh,
    jdyxqZ: validUntilText
  };
}

export const pgxmManageService = {
  currentStandard: () => axios.get(`${baseUrl}/standard/current`),
  standardTree: bzdm => axios.get(`${baseUrl}/standard/tree`, { params: { bzdm } }),
  query: params => axios.get(`${baseUrl}/project`, { params: queryToJx(params) })
    .then(mapPageResponse),
  getPgyj: () => axios.get(`${baseUrl}/standard/current`),
  save: form => axios.post(`${baseUrl}/project`, projectToJx(form)),
  update: (id, form) => axios.put(`${baseUrl}/project/${id}`, projectToJx(form)),
  delete: (id, lockVersion) => axios.delete(`${baseUrl}/project/${id}`, {
    params: { lockVersion }
  }),
  getDetail: id => axios.get(`${baseUrl}/project/${id}`)
    .then(response => ({ ...response, data: projectFromJx(response.data) })),
  setting: id => axios.get(`${baseUrl}/project/${id}/setting`),
  saveSetting: (id, form) => axios.put(`${baseUrl}/project/${id}/setting`, form),
  // 评估仪器候选沿用广东公共查询接口；江西只负责保存项目仪器快照。
  instruments: () => pgyqManageService.query({
    sfqy: 'Y',
    pageNo: 1,
    pageSize: 1000
  }).then(response => ({
    ...response,
    data: ((response.data || {}).rows || []).map(mapInstrumentOption)
  })),
  signIns: id => axios.get(`${baseUrl}/sign-in/project/${id}`),
  executionCatalog: id => axios.get(`${baseUrl}/execution/${id}/catalog`),
  executionDetail: id => axios.get(`${baseUrl}/execution/content/${id}`),
  saveExecution: (id, form) => axios.put(`${baseUrl}/execution/content/${id}`, form),
  issuePage: params => axios.get(`${baseUrl}/issue`, { params }),
  issueDetail: id => axios.get(`${baseUrl}/issue/${id}`),
  saveIssue: form => axios.post(`${baseUrl}/issue`, form),
  updateIssue: (id, form) => axios.put(`${baseUrl}/issue/${id}`, form),
  deleteIssue: (id, lockVersion) => axios.delete(`${baseUrl}/issue/${id}`, {
    params: { lockVersion }
  }),
  reportPage: params => axios.get(`${baseUrl}/report`, { params }),
  reportPrepare: id => axios.get(`${baseUrl}/report/project/${id}/prepare`),
  saveReportPreparation: (id, form) => axios.put(`${baseUrl}/report/project/${id}/prepare`, form),
  previewReport: id => axios.post(`${baseUrl}/report/project/${id}/preview`),
  generateReport: id => axios.post(`${baseUrl}/report/project/${id}/generate`),
  downloadReport: (id, fileType) => axios.get(`${baseUrl}/report/${id}/file/${fileType}`, {
    responseType: 'blob'
  }),
  reevaluate: (id, form) => axios.post(`${baseUrl}/project/${id}/reevaluate`, form)
};
